export default __webpack_public_path__ + "static/media/purple.fc02bfdb.svg";